import {useEffect, useId, useState} from 'react'
import {getPrefs, setPrefs} from '../auth'
import {JanelaRef, Periodo} from '../types'

interface Props {
  value: JanelaRef
  custom?: Periodo
  onChange: (ref: JanelaRef, custom?: Periodo) => void
}

export default function JanelaRefSelect({value, custom, onChange}: Props) {
  const id = useId()
  const [draft, setDraft] = useState<Periodo>(custom ?? {})
  useEffect(() => {
    setDraft({de: custom?.de, ate: custom?.ate})
  }, [custom?.de, custom?.ate])
  const invalid = !!(draft.de && draft.ate && draft.de > draft.ate)
  const aplicar = (janela_ref: JanelaRef, c: Periodo | undefined = custom) => {
    setPrefs({...getPrefs(), janela_ref, custom_de: c?.de, custom_ate: c?.ate})
    onChange(janela_ref, c)
  }
  const escolher = (next: JanelaRef) => {
    if (next !== 'CUSTOM') {
      aplicar(next)
      return
    }
    const now = new Date()
    const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(
      now.getDate()
    ).padStart(2, '0')}`
    const range =
      custom?.de && custom?.ate && custom.de <= custom.ate
        ? custom
        : {de: `${today.slice(0, 7)}-01`, ate: today}
    setDraft(range)
    aplicar('CUSTOM', range)
  }
  const atualizar = (field: 'de' | 'ate', date: string) => {
    const next = {...draft, [field]: date}
    setDraft(next)
    if (next.de && next.ate && next.de <= next.ate) aplicar('CUSTOM', next)
  }
  return (
    <>
      <label className='filter-field' htmlFor={`${id}-ref`}>
        <span>Referência</span>
        <select
          id={`${id}-ref`}
          value={value}
          onChange={(e) => escolher(e.target.value as JanelaRef)}
        >
          <option value='YTD'>Ano até hoje (YTD)</option>
          <option value='12M'>12 meses móveis</option>
          <option value='ANO_ANT'>Ano anterior</option>
          <option value='CUSTOM'>Personalizado</option>
        </select>
      </label>
      {value === 'CUSTOM' && (
        <div className='filter-dates'>
          <label className='filter-field' htmlFor={`${id}-de`}>
            <span>Data inicial</span>
            <input
              id={`${id}-de`}
              type='date'
              required
              value={draft.de || ''}
              aria-invalid={invalid}
              aria-describedby={invalid ? `${id}-error` : undefined}
              onChange={(e) => atualizar('de', e.target.value)}
            />
          </label>
          <label className='filter-field' htmlFor={`${id}-ate`}>
            <span>Data final</span>
            <input
              id={`${id}-ate`}
              type='date'
              required
              value={draft.ate || ''}
              aria-invalid={invalid}
              aria-describedby={invalid ? `${id}-error` : undefined}
              onChange={(e) => atualizar('ate', e.target.value)}
            />
          </label>
          {invalid && (
            <span id={`${id}-error`} className='field-error' role='alert'>
              A data final deve ser igual ou posterior à inicial.
            </span>
          )}
          {(!draft.de || !draft.ate) && (
            <span className='field-error'>Preencha as duas datas para aplicar o período.</span>
          )}
        </div>
      )}
    </>
  )
}
